<template>
  <FormFileUpload ref="uploadRef" v-model="documentItems" />
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import FormFileUpload, { type FileUploadItem } from '@/js/components/form/form-file-upload.vue';

const documentItems = ref<FileUploadItem[]>([]);
const uploadRef = ref<InstanceType<typeof FormFileUpload> | null>(null);

defineExpose({
  getReadyFiles: () => uploadRef.value?.getReadyFiles() ?? [],
  reset: () => uploadRef.value?.reset(),
  setSubmittingState: (isSubmitting: boolean) => uploadRef.value?.setSubmittingState(isSubmitting),
  resetSubmittingState: () => uploadRef.value?.resetSubmittingState(),
});
</script>
